module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-motivation-getting-help@2x.a41e3c36.png";